//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'LogJobList',
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      pagePath: '/sys/log/job',
      pageTitle: '任务日志表',
      isorter: {
        column: 'id',
        order: 'desc'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'fireInstanceId',
        colName: 'fire_instance_id',
        title: '任务实例',
        align: 'center' // sorter: true

      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '执行结果',
        align: 'center',
        customRender: function customRender(text) {
          if (text == 0) {
            return '执行失败';
          } else if (text == 1) {
            return '执行成功';
          } else {
            return text;
          }
        }
      }, {
        dataIndex: 'method',
        colName: 'method',
        title: '请求方法',
        align: 'center'
      }, // {
      //   dataIndex: 'param',
      //   colName: 'param',
      //   title: '请求参数',
      //   align: 'center',
      //
      // },
      {
        dataIndex: 'costTime',
        colName: 'cost_time',
        title: '耗时(毫秒)',
        align: 'center'
      }, {
        dataIndex: 'createTime',
        colName: 'create_time',
        title: '开始时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'updateTime',
        colName: 'update_time',
        title: '结束时间',
        align: 'center',
        sorter: true
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};